export enum RoleName {
  ROLE_USER,
  ROLE_ADMIN,
  ROLE_PORTAL_USER
}
